import React from 'react';
import { Container, Icon } from 'semantic-ui-react';
import { getWaitingAreaLogoPauseImage } from 'actions/waitingArea.js';
import { showWaitingAreaLogoPauseImageModal } from 'actions/modal.js';
import { Media } from '../../../mediaSetting';
import { useDispatch } from 'react-redux';

export default function BottomLogo(props) {
  if (props.waitingArea && props.waitingArea.isCustomBrandingEnabled) {
    return (
      <div className="pdtl pdbl">
        <CustomBrandingLogo
          wrapperClass="center-with-margin"
          waitingArea={props.waitingArea}
          isDisplayingDefaultLogo={!(props.waitingArea.logoUrls.logoUrl || props.waitingArea.logoUrls.orgLogoUrl)}
        />
      </div>
    );
  } else {
    return (
      <div>
        <Container
          fluid
          as={Media}
          at="mobile"
          className="pdtl pdbl"
          style={{
            borderTop: '1px solid #fff',
            width: '200px',
            margin: '0 auto',
          }}
        >
          <img
            className="ui image"
            style={{ height: '67px', margin: '0 auto' }}
            src={APP.IMAGES.UmbrellaLogo.default}
          />
        </Container>
        <Container
          fluid
          as={Media}
          at="tablet"
          className="pdtl pdbl"
          style={{
            borderTop: '1px solid #fff',
            width: '250px',
            margin: '0 auto',
          }}
        >
          <img
            className="ui image"
            style={{ height: '84px', margin: '0 auto' }}
            src={APP.IMAGES.UmbrellaLogo.default}
          />
        </Container>
      </div>
    );
  }
}

export function CustomBrandingLogo(props) {
  const dispatch = useDispatch();
  if (props.isDisplayingDefaultLogo) {
    return (
      <div
        className={props.wrapperClass + ' branding-logo-on-right-hand hand'}
        onClick={() => {
          let cb = () => {
            dispatch(showWaitingAreaLogoPauseImageModal(true));
          };
          dispatch(getWaitingAreaLogoPauseImage(props.waitingArea.id, cb));
        }}
      >
        <div className="display-flex center-flex full-height relative">
          <img className="ui image" src={props.waitingArea.logoUrls.defaultSystemLogoUrl} />
          <YourLogoHere />
        </div>
      </div>
    );
  } else {
    return (
      <div className={props.wrapperClass + ' branding-logo-on-right-hand'}>
        <img className="ui image" src={props.waitingArea.logoUrls.logoUrl || props.waitingArea.logoUrls.orgLogoUrl} />
      </div>
    );
  }
}

export function YourLogoHere(props) {
  return (
    <div className="absolute your-logo-here-edit-btn">
      <Icon name="pencil" />
    </div>
  );
}
